import { IApiEntry, IWebOwlErrorCategory, IWebOwlErrorLevel } from '@zhenguo/types'
import { AnyJSON } from '@zhenguo/types/common'
import Agent from './agent'
import { E_ProcessEnv, getProcessEnv } from './base/env'
import User from './user'

enum ERROR_LEVEL {
  error = 'error',
  info = 'info',
  debug = 'debug',
  warn = 'warn',
}

export const addApi = function (data: IApiEntry) {
  try {
    window.owl && window.owl('addApi', data)
  } catch (err) {
    // 忽略 owl 异常
    console.warn(err)
  }
}

function processValue(value?: { toString: () => string }) {
  if (!value) return ''
  if (typeof value !== 'string') {
    try {
      if (value instanceof Error) {
        return value.toString()
      } else {
        return JSON.stringify(value)
      }
    } catch (e) {
      console.log(value)
      return '未知错误'
    }
  }
  return value
}

interface ERR {
  name: any
  msg?: any
  global?: boolean
}
interface OPTS {
  combo?: boolean
  category?: IWebOwlErrorCategory
  level?: IWebOwlErrorLevel
  tags?: AnyJSON
}

export const reportError = function (err: ERR, opts?: OPTS) {
  try {
    const newError = {
      name: processValue(err.name),
      msg: processValue(err.msg),
    }
    if (err.global) {
      newError.name = 'global|' + newError.name
    }
    window.owl &&
      window.owl('addError', newError, {
        ...opts,
        tags: {
          ...Agent,
          uuid: User.uuid,
          userId: User.userId,
        },
      })
  } catch (err) {
    // 忽略 owl 异常
    console.warn(err)
  }
}

export const reportInfo = function (err: ERR, opts?: OPTS) {
  reportError(err, {
    level: ERROR_LEVEL.info,
    ...opts,
  })
}

export const reportWarn = function (err: ERR, opts?: OPTS) {
  reportError(err, {
    level: ERROR_LEVEL.warn,
    ...opts,
  })
}

export const reportMetric = function (metricName: string, metricValue: number, tags: AnyJSON) {
  try {
    const metricInst = window.owl && window.owl('newMetricInst')
    metricInst &&
      metricInst.setTags({
        ...Agent,
        page: getProcessEnv(E_ProcessEnv.VUE_APP_PROJECT_NAME),
        ...tags,
      })
    metricInst && metricInst.setMetric(metricName, metricValue)
    metricInst && metricInst.report()
  } catch (err) {
    // 忽略 owl 异常
    console.warn(err)
  }
}
